// extracted by mini-css-extract-plugin
export var banner = "_h5-0";
export var closeButton = "_h5-2";
export var greenCheckmark = "_h5-3";
export var hereLink = "_h5-4";
export var titleIcon = "_h5-1";